import React from "react";
import MultiModalPickerWithChooseButton from "../MultiModalPickerWithChooseButton";
import { MultiModalPickerProps } from "../props";
import MultiContactList from "./MultiContactList";
import { LabelList } from "../LabelList";

export const ContactMultiModalPicker = (props: MultiModalPickerProps<server.dto.ContactSmallV2>) => {

  return <>
    <MultiModalPickerWithChooseButton<server.dto.ContactSmallV2>
      onNewClicked={() => { }}
      renderLabelContent={contact => <div>{contact.name.fullName}</div>}
      getId={(contact) => contact.contactId}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Contact.Contacts}
      modalSize="small"
      renderModalContent={(editedValue, setEditedValue) => <MultiContactList
        excludeKeys={editedValue.map(contact => contact.contactId)}
        onChange={setEditedValue}
        value={editedValue}
      />}

      {...props}
    />
  </>;
};

export const SelectedContacts = (props: { value: server.dto.ContactSmallV2[] }) => {
  return <LabelList
    value={props.value}
    renderLabelContent={contact => <div>{contact.name.fullName}</div>}
    getId={(contact) => contact.contactId}
  />;
}